import { render, staticRenderFns } from "./AgeRequirementSelect.vue?vue&type=template&id=2dda7da6&"
import script from "./AgeRequirementSelect.vue?vue&type=script&lang=js&"
export * from "./AgeRequirementSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports